"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _default = exports.default = {
  name: 'wl-upload-image',
  props: {
    value: {
      type: String,
      default: ''
    }
  },
  data: function data() {
    return {
      images: []
    };
  },
  watch: {
    value: {
      handler: function handler(nv) {
        this.images = nv !== null && nv !== void 0 ? nv : '';
      },
      deep: true,
      immediate: true
    },
    images: {
      handler: function handler(nv, ov) {
        this.$emit('input', nv);
        this.$emit('change', nv, ov);
      },
      deep: true,
      immediate: true
    }
  }
};